import type { FormikProps } from "formik";
import type React from "react";
import { useEffect } from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import type { Project, User } from "senf-shared/types";
import { fetchProjectSpecificData } from "../../../../util/demographicUtils";
import DemographicsForm from "../../../templates/demographics/DemographicsForm";

interface SurveyDemographicsProps {
  demographicsFormik: FormikProps<User>;
  project: Project;
  user: User;
}

const SurveyDemographics: React.FC<SurveyDemographicsProps> = ({
  demographicsFormik,
  project,
  user,
}) => {
  useEffect(() => {
    const loadProjectSpecificData = async () => {
      const participantData = await fetchProjectSpecificData(project, user);
      if (participantData) {
        demographicsFormik.setValues((prevValues) => ({
          ...prevValues,
          ...participantData,
        }));
      }
    };

    loadProjectSpecificData();
  }, [project, user]);

  return (
    <div className="flex flex-col gap-4">
      <DemographicsForm
        formik={demographicsFormik}
        project={project}
        user={user}
        isAuthFlow={false}
      />
      <span className="body-sm text-text-subdued">
        <Trans i18nKey="auth:privacyStatement">
          ...
          <Link
            to={`/projects/${project?.projectId}/privacyPolicy`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "underline",
              fontWeight: "500",
            }}
          />
          ...
        </Trans>
      </span>
    </div>
  );
};

export default SurveyDemographics;
